// src/components/Stand.js
import React, { useRef } from 'react';
import { Cylinder, Sphere } from '@react-three/drei';
import * as THREE from 'three'; // Не обязательно здесь, если не создаем материалы с THREE.Color

export function Stand({
                          position,
                          baseColor = "#1A1A1A",
                          emissiveDotColor = "#EAEAEA",
                          innerRingColor = "#FAFAFA",
                          geoHeight = 0.3,  // <<<--- Высота подставки теперь четко из пропса
                          geoRadius = 2.5   // <<<--- Радиус подставки теперь четко из пропса
                      }) {
    const groupRef = useRef();
    const innerRingRadius = geoRadius * 0.85;
    const innerRingHeight = 0.03;
    const dotRadius = 0.06;
    const numDots = 20;

    return (
        <group ref={groupRef} position={position}>
            {/* Основная часть подставки */}
            <Cylinder args={[geoRadius, geoRadius, geoHeight, 64]} receiveShadow castShadow>
                <meshStandardMaterial color={baseColor} metalness={0.4} roughness={0.8} />
            </Cylinder>

            {/* Белый внутренний круг */}
            <Cylinder
                args={[innerRingRadius, innerRingRadius, innerRingHeight, 64]}
                // Позиционируем на верхней поверхности основного цилиндра
                position={[0, geoHeight / 2 - innerRingHeight / 2 + 0.001, 0]}
            >
                <meshStandardMaterial color={innerRingColor} emissive={innerRingColor} emissiveIntensity={1.5} toneMapped={false}/>
            </Cylinder>

            {/* Белые точки по краю */}
            {Array.from({ length: numDots }).map((_, i) => {
                const angle = (i / numDots) * Math.PI * 2;
                const x = Math.cos(angle) * (geoRadius - dotRadius * 1.5);
                const z = Math.sin(angle) * (geoRadius - dotRadius * 1.5);
                return (
                    <Sphere
                        key={`dot-${i}`}
                        args={[dotRadius, 16, 16]}
                        // Позиционируем на верхней поверхности основного цилиндра
                        position={[x, geoHeight / 2 - dotRadius / 2 + 0.001, z]}
                    >
                        <meshStandardMaterial color={emissiveDotColor} emissive={emissiveDotColor} emissiveIntensity={1.0} toneMapped={false}/>
                    </Sphere>
                );
            })}
        </group>
    );
}